import { AppThunk } from "services/redux/rootReducer";
import { getDataFromRequest } from "services/axios/utility/helper";
import { ENDPOINT } from "services/axios/constants/endpoints";
import { HTTPMethods } from "services/axios/types/http";
import { getToken } from "features/auth/functions/token";

const restoreBackup =
    (collections: string[], inputUriPrefix: string): AppThunk<Promise<void>> =>
    async () => {
        await getDataFromRequest(
            ENDPOINT.FUNCTIONS_API.BACKUPS.RESTORE,
            HTTPMethods.POST,
            getToken(),
            {
                collections,
                inputUriPrefix,
            }
        );
        return;
    };

export default restoreBackup;
